
class DataModel {
    constructor(report){


    }


setTotals(aggregate){
    var totals = {};
    var averages = {};
    var inc = 0;
    if (aggregate.current && aggregate.keys){
        for (var m of Object.keys(aggregate.current)){
                var a = aggregate.current[m];
                a.map((o) => {
                    inc++;
                for (var k of aggregate.keys){
                    var arridx = aggregate.keys.indexOf(k);
                    
                    totals[arridx] = (totals[arridx]) ? totals[arridx] : (isNaN(o.metrics[arridx])) ? false : o.metrics[arridx];
                    averages[arridx] = (averages[arridx]) ? averages[arridx] : 0;
                    if (totals[arridx]){
                        totals[arridx] += o.metrics[arridx];
                        averages[arridx] = totals[arridx] / inc;
                        
                    }
                }
            });
        }
    }
    aggregate.totals = totals;
    aggregate.averages = averages;
    return aggregate;
}


}
export default DataModel;